import { PrimaryCTALink } from '@ovotech/nebula';
import { AnalyticsClick, useAnalytics } from '@ovotech/ui-tools';
import React, { useEffect } from 'react';
import { Media } from '@/src/components/Media';
import {
  DesktopContainer,
  KiaLeftContent,
  KiaMobileContainer,
  KiaRightContent,
} from './KiaAnytimeAppLink.styled';
import { breakpoints } from '@/src/utils/mediaQuery';
// TODO: Replace with Kia specific logo when available
import KIA_APP from '@/src/resources/kia-app.png';
import {
  KIA_CAR_APP_LINK,
  EV,
  useChargeAnytimeContext,
} from '@monovo/ev-anytime';
import { PageHeader } from '@/src/pages/AnytimeEligibilityV2/components/PageHeader';
import { PageWithNavigation } from '@/src/components';
import { P } from '@ovotech/element-v5';
import { MobileOS, getDeviceOS } from '@/src/utils/getDeviceOS';

export const KiaAnytimeAppLink = () => {
  const { dispatch } = useAnalytics();
  const { integration } = useChargeAnytimeContext();

  const getKiaCarAppLink = () => {
    if (integration?.integrationType !== 'Kia') {
      return KIA_CAR_APP_LINK;
    }

    const { googlePlayStore, appleAppStore, webRedirect } =
      integration.integrationForwardUrl;
    const deviceOS = getDeviceOS();

    if (deviceOS === MobileOS.ANDROID && googlePlayStore) {
      return googlePlayStore;
    }

    if (deviceOS === MobileOS.IOS && appleAppStore) {
      return appleAppStore;
    }

    return webRedirect || KIA_CAR_APP_LINK;
  };

  const kiaCarAppLink = getKiaCarAppLink();

  useEffect(() => {
    dispatch({
      type: 'view',
      name: EV.ELIGIBILITY.EVS_OVO_CHARGE_ANYTIME_KIA_APP_VIEWED,
      properties: {
        Screen: EV.SCREENS.DOWNLOAD_KIA_APP,
        journeyName: 'Charge Anytime',
      },
    });
    // `dispatch` method is not memoized, and it causes useless calls.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({
      type: 'view',
      name: 'EVS - OVO Charge Anytime Kia app link viewed',
      properties: {
        Screen: EV.SCREENS.DOWNLOAD_KIA_APP,
        journeyName: 'Charge Anytime',
      },
    });
    // `dispatch` method is not memoized, and it causes useless calls.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWithNavigation title="Charge Anytime">
      <PageHeader
        data-testid="success-message"
        title={'Activate Charge Anytime'}
        showDescription={false}
      />
      <Media query={breakpoints.mediumUp}>
        <DesktopContainer>
          <KiaLeftContent>
            <img src={KIA_APP} alt="EV Anytime Kia App" />
          </KiaLeftContent>
          <KiaRightContent>
            <P>
              Now, just go back to your Kia app, link your account, and start
              charging!
            </P>
            <AnalyticsClick
              name={
                EV.ELIGIBILITY.EVS_OVO_CHARGE_ANYTIME_KIA_CAR_APP_LINK_CLICKED
              }
            >
              <PrimaryCTALink
                data-event-name={'EVS - EVS OVO Drive Anytime kia link clicked'}
                opensInNewWindow
                href={kiaCarAppLink}
              >
                Go to your Kia app
              </PrimaryCTALink>
            </AnalyticsClick>
          </KiaRightContent>
        </DesktopContainer>
      </Media>

      <Media query={breakpoints.mediumDown}>
        <KiaMobileContainer>
          <P>
            Now, just go back to your Kia app, link your account, and start
            charging!
          </P>
          <img src={KIA_APP} alt="EV Anytime Kia App" />
          <AnalyticsClick
            name={
              EV.ELIGIBILITY.EVS_OVO_CHARGE_ANYTIME_KIA_CAR_APP_LINK_CLICKED
            }
          >
            <PrimaryCTALink
              data-event-name={'EVS - EVS OVO Drive Anytime kia link clicked'}
              opensInNewWindow
              href={kiaCarAppLink}
            >
              Go to your Kia app
            </PrimaryCTALink>
          </AnalyticsClick>
        </KiaMobileContainer>
      </Media>
    </PageWithNavigation>
  );
};
